module.exports = new __parcel__URL__("mendingcrystals.6fd1c15e.png").toString();